import { useState, useEffect, useCallback } from 'react';

const NAV_ITEMS = [
  { label: '首页', href: '#hero' },
  { label: 'APP下载', href: '#app' },
  { label: '常见问题', href: '#faq' },
  { label: '焦点专题', href: '#carousel' },
  { label: '关于我们', href: '#about' },
  { label: '热门话题', href: '#topics' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px]">
          {/* Logo */}
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
            className="flex items-center gap-2 shrink-0 cursor-pointer"
          >
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-play-circle-fill text-background-50 text-xl"></i>
            </div>
            <span className="font-heading text-xl text-foreground-950 whitespace-nowrap">
              榴莲视频
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className={`px-4 py-2 text-sm font-medium rounded-full transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                    : 'text-foreground-50/90 hover:text-background-50 hover:bg-foreground-950/20'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-3">
            <a
              href="#app"
              onClick={(e) => { e.preventDefault(); handleNavClick('#app'); }}
              className="px-5 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              立即体验
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${scrolled ? 'text-foreground-950' : 'text-background-50'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#app"
              onClick={(e) => { e.preventDefault(); handleNavClick('#app'); }}
              className="mt-2 px-5 py-3 text-sm font-medium bg-primary-500 text-background-50 rounded-lg text-center hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              立即体验
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}